export const translationsES = {
  // ─── Navegación ────────────────────────────────────────────────────────────
  'nav.home': 'Inicio',
  'nav.matching': 'Compatibilidad',
  'nav.search': 'Buscar',
  'nav.projects': 'Proyectos',
  'nav.marketplace': 'Mercado',
  'nav.dashboard': 'Panel',
  'nav.messages': 'Mensajes',
  'nav.profile': 'Perfil',
  'nav.logout': 'Cerrar sesión',
  'nav.settings': 'Configuración',
  'nav.notifications': 'Notificaciones',

  // ─── Común ─────────────────────────────────────────────────────────────────
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.close': 'Cerrar',
  'common.submit': 'Enviar',
  'common.search': 'Buscar',
  'common.filter': 'Filtrar',
  'common.loading': 'Cargando...',
  'common.error': 'Error',
  'common.success': 'Éxito',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.view': 'Ver',
  'common.download': 'Descargar',
  'common.upload': 'Subir',
  'common.send': 'Enviar',
  'common.apply': 'Aplicar',
  'common.accept': 'Aceptar',
  'common.reject': 'Rechazar',
  'common.confirm': 'Confirmar',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.create': 'Crear',
  'common.update': 'Actualizar',
  'common.remove': 'Eliminar',
  'common.share': 'Compartir',
  'common.copied': '¡Copiado!',
  'common.noData': 'Sin datos disponibles',
  'common.errorSaving': 'Error al guardar los cambios',
  'common.errorLoading': 'Error al cargar los datos',
  'common.viewAll': 'Ver todo',
  'common.seeMore': 'Ver más',
  'common.seeLess': 'Ver menos',
  'common.optional': 'Opcional',
  'common.required': 'Requerido',
  'common.retry': 'Reintentar',

  // ─── Autenticación ─────────────────────────────────────────────────────────
  'auth.login': 'Iniciar Sesión',
  'auth.register': 'Registrarse',
  'auth.email': 'Correo Electrónico',
  'auth.password': 'Contraseña',
  'auth.confirmPassword': 'Confirmar Contraseña',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.noAccount': '¿No tienes cuenta?',
  'auth.hasAccount': '¿Ya tienes cuenta?',
  'auth.loginError': 'Email o contraseña inválidos',
  'auth.registerError': 'Registro fallido',
  'auth.passwordMismatch': 'Las contraseñas no coinciden',
  'auth.emailRequired': 'El correo es requerido',
  'auth.passwordRequired': 'La contraseña es requerida',
  'auth.loginSuccess': 'Sesión iniciada exitosamente',
  'auth.registerSuccess': 'Cuenta creada exitosamente',
  'auth.logoutSuccess': 'Sesión cerrada exitosamente',
  'auth.emailPlaceholder': 'tu@email.com',
  'auth.passwordPlaceholder': 'Al menos 8 caracteres',
  'auth.fullName': 'Nombre Completo',
  'auth.fullNamePlaceholder': 'Tu nombre completo',
  'auth.creatingAccount': 'Creando cuenta...',
  'auth.loggingIn': 'Iniciando sesión...',
  'auth.registerConfirmRequired': 'Revisá tu correo para confirmar tu cuenta',
  'auth.registerConfirmHint': 'Te enviamos un enlace de verificación a {email}',
  'auth.welcomeTitle': 'Bienvenido a Resuena',
  'auth.welcomeSubtitle': 'Conectate con músicos de todo el mundo',
  'auth.registerTitle': 'Creá tu cuenta',
  'auth.registerSubtitle': 'Sumate a la comunidad musical',

  // ─── Panel de Control ──────────────────────────────────────────────────────
  'dashboard.welcome': 'Bienvenido de nuevo',
  'dashboard.subtitle': 'Aquí tenés un resumen de tu actividad de hoy.',
  'dashboard.quickActions': 'Acciones Rápidas',
  'dashboard.recentActivity': 'Actividad Reciente',
  'dashboard.upcomingEvents': 'Próximos Eventos',
  'dashboard.nearbyMusicians': 'Músicos Cercanos',
  'dashboard.applications': 'Aplicaciones',
  'dashboard.bookings': 'Reservas',
  'dashboard.findMusicians': 'Buscar Músicos',
  'dashboard.createProject': 'Crear Proyecto',
  'dashboard.postGig': 'Publicar Trabajo',
  'dashboard.viewProfile': 'Ver Perfil',
  'dashboard.noActivity': 'Sin actividad reciente',
  'dashboard.noEvents': 'Sin eventos próximos',
  'dashboard.totalWorkload': 'Carga Total',
  'dashboard.completedTasks': 'Completadas',
  'dashboard.pendingTasks': 'Pendientes',
  'dashboard.productivity': 'Productividad',
  'dashboard.tasks': 'tareas',
  'dashboard.high': 'Alta',
  'dashboard.medium': 'Media',
  'dashboard.low': 'Baja',
  'dashboard.priorityOverview': 'Resumen de Prioridades',
  'dashboard.viewAllActivities': 'Ver Toda la Actividad',
  'dashboard.performance': 'Rendimiento',
  'dashboard.weeklyGoal': 'Meta Semanal',
  'dashboard.achievements': 'Logros',
  'dashboard.collaborations': 'Colaboraciones',
  'dashboard.activeProjects': 'Proyectos Activos',
  'dashboard.pendingMessages': 'Mensajes No Leídos',
  'dashboard.goLive': 'Transmitir en Vivo',
  'dashboard.events': 'Eventos',

  // ─── Perfil ────────────────────────────────────────────────────────────────
  'profile.myProfile': 'Mi Perfil',
  'profile.personalInfo': 'Información Personal',
  'profile.skills': 'Habilidades',
  'profile.genres': 'Géneros',
  'profile.portfolio': 'Portafolio',
  'profile.name': 'Nombre',
  'profile.bio': 'Biografía',
  'profile.location': 'Ubicación',
  'profile.website': 'Sitio Web',
  'profile.phone': 'Teléfono',
  'profile.avatar': 'Foto de Perfil',
  'profile.updateSuccess': 'Perfil actualizado exitosamente',
  'profile.updateError': 'Error al actualizar el perfil',
  'profile.addSkill': 'Agregar Habilidad',
  'profile.addGenre': 'Agregar Género',
  'profile.skillLevel': 'Nivel de Habilidad',
  'profile.yearsExperience': 'Años de Experiencia',
  'profile.uploadTrack': 'Subir Pista',
  'profile.trackTitle': 'Título de la Pista',
  'profile.trackDescription': 'Descripción',
  'profile.profileUpdated': 'Perfil actualizado',
  'profile.profileNotFound': 'Perfil no encontrado',
  'profile.myPortfolio': 'Mi Portafolio',
  'profile.myTracks': 'Mis Pistas',
  'profile.noTracksYet': 'Todavía no subiste ninguna pista',
  'profile.musicalSkills': 'Habilidades Musicales',
  'profile.favoriteGenres': 'Géneros Favoritos',
  'profile.availability': 'Disponibilidad',
  'profile.availableForCollabs': 'Disponible para colaboraciones',
  'profile.availableForGigs': 'Disponible para trabajos',
  'profile.editProfile': 'Editar Perfil',
  'profile.tabs.personal': 'Personal',
  'profile.tabs.portfolio': 'Portafolio',
  'profile.tabs.skills': 'Habilidades',
  'profile.tabs.genres': 'Géneros',
  'profile.tabs.availability': 'Disponibilidad',
  'profile.tabs.notifications': 'Notificaciones',
  'profile.bioPlaceholder': 'Contanos sobre vos y tu música...',
  'profile.locationPlaceholder': 'Ciudad, País',
  'profile.websitePlaceholder': 'https://tu-sitio.com',
  'profile.primaryInstrument': 'Instrumento Principal',
  'profile.primaryGenre': 'Género Principal',
  'profile.experienceYears': 'Años de Experiencia',
  'profile.artistName': 'Nombre Artístico',
  'profile.changePhoto': 'Cambiar Foto',
  'profile.uploadPhoto': 'Subir Foto',

  // ─── Compatibilidad / Matching ─────────────────────────────────────────────
  'matching.title': 'Compatibilidad Musical',
  'matching.subtitle': 'Encontrá tu compañero musical ideal',
  'matching.aiTitle': 'Matching de Músicos con Inteligencia Artificial',
  'matching.aiSubtitle': 'Sistema inteligente que analiza la compatibilidad en múltiples dimensiones',
  'matching.compatibility': 'Compatibilidad',
  'matching.sendRequest': 'Enviar Solicitud de Colaboración',
  'matching.viewProfile': 'Ver Perfil',
  'matching.noMatches': 'No se encontraron coincidencias',
  'matching.noMatchesHint': 'Intentá ajustar tus filtros',
  'matching.requestSent': '¡Solicitud de colaboración enviada!',
  'matching.requestError': 'Error al enviar la solicitud',
  'matching.filters': 'Filtros Inteligentes',
  'matching.filtersSubtitle': 'Ajustá tu búsqueda con filtros impulsados por IA',
  'matching.distance': 'Distancia',
  'matching.minCompatibility': 'Puntaje de Compatibilidad',
  'matching.minMatch': 'Porcentaje de Coincidencia',
  'matching.sortBy': 'Ordenar Por',
  'matching.sortByMatch': 'Porcentaje de Coincidencia',
  'matching.sortByCompatibility': 'Puntaje de Compatibilidad',
  'matching.availability': 'Disponibilidad',
  'matching.allMusicians': 'Todos los Músicos',
  'matching.openForCollab': 'Disponibles para Colaborar',
  'matching.availableForGigs': 'Disponibles para Trabajos',
  'matching.recalculate': 'Recalcular Coincidencias',
  'matching.aiRecommended': 'Recomendados por IA',
  'matching.allMatches': 'Todas las Coincidencias',
  'matching.totalMatches': 'Total de Coincidencias',
  'matching.highCompatibility': 'Alta Compatibilidad',
  'matching.perfectMatches': 'Coincidencias Perfectas',
  'matching.complementarySkills': 'Habilidades Complementarias',
  'matching.searchMusicians': 'Buscar Músicos',
  'matching.searchPlaceholder': 'Nombre o palabras clave de la bio...',
  'matching.locationFilter': 'Ubicación',
  'matching.locationPlaceholder': 'Ciudad, provincia o país...',
  'matching.suggestion.sharedTastes': 'Sus gustos musicales compartidos son una base excelente para colaborar.',
  'matching.suggestion.complementarySkills': 'Sus habilidades complementarias pueden formar una colaboración musical muy completa.',
  'matching.suggestion.sameArea': 'Estar en la misma zona facilita coordinar ensayos y colaboraciones presenciales.',
  'matching.suggestion.strongPotential': 'Tienen un potencial fuerte para una colaboración creativa.',
  'matching.suggestion.differentPerspectives': 'Sus perspectivas diferentes pueden abrir oportunidades musicales únicas.',

  // ─── Búsqueda ──────────────────────────────────────────────────────────────
  'search.title': 'Buscar Músicos',
  'search.subtitle': 'Descubrí músicos talentosos cerca tuyo para colaborar',
  'search.placeholder': 'Buscar por nombre, instrumento o género...',
  'search.results': 'Resultados',
  'search.noResults': 'No se encontraron resultados',
  'search.noResultsHint': 'Intentá ajustar los filtros de búsqueda',
  'search.filters': 'Filtros',
  'search.instrument': 'Instrumento',
  'search.genre': 'Género',
  'search.location': 'Ubicación',
  'search.availability': 'Disponibilidad',
  'search.mapView': 'Vista de Mapa',
  'search.listView': 'Vista de Lista',
  'search.savedSearches': 'Búsquedas Guardadas',
  'search.saveSearch': 'Guardar Búsqueda',
  'search.saveSearchTitle': 'Guardar Preferencia de Búsqueda',
  'search.saveSearchSubtitle': 'Guardá los filtros actuales para acceder rápidamente más tarde',
  'search.preferenceName': 'Nombre de la Preferencia',
  'search.preferenceNamePlaceholder': 'Ej: Músicos de Jazz en Buenos Aires',
  'search.searchSaved': 'Preferencia de búsqueda guardada',
  'search.searchSaveError': 'Error al guardar la preferencia',
  'search.preferenceDeleted': 'Preferencia eliminada',
  'search.preferenceDeleteError': 'Error al eliminar la preferencia',

  // ─── Proyectos ─────────────────────────────────────────────────────────────
  'projects.title': 'Proyectos',
  'projects.create': 'Crear Nuevo Proyecto',
  'projects.myProjects': 'Mis Proyectos',
  'projects.myApplications': 'Mis Aplicaciones',
  'projects.name': 'Nombre del Proyecto',
  'projects.description': 'Descripción',
  'projects.status': 'Estado',
  'projects.budget': 'Presupuesto',
  'projects.deadline': 'Fecha Límite',
  'projects.roles': 'Roles Necesarios',
  'projects.addRole': 'Agregar Rol',
  'projects.applications': 'Aplicaciones',
  'projects.timeline': 'Cronograma',
  'projects.tasks': 'Tareas',
  'projects.createSuccess': 'Proyecto creado exitosamente',
  'projects.createError': 'Error al crear el proyecto',
  'projects.updateSuccess': 'Proyecto actualizado exitosamente',
  'projects.deleteConfirm': '¿Estás seguro de que querés eliminar este proyecto?',
  'projects.deleteSuccess': 'Proyecto eliminado exitosamente',
  'projects.deleteError': 'Error al eliminar el proyecto',
  'projects.members': 'Miembros',
  'projects.owner': 'Propietario',
  'projects.updatedAt': 'Última Actualización',
  'projects.invite': 'Invitar',
  'projects.manage': 'Gestionar',
  'projects.noProjects': 'No se encontraron proyectos',
  'projects.noApplications': 'No se encontraron aplicaciones',
  'projects.filterAll': 'Todos',
  'projects.filterActive': 'Activos',
  'projects.filterCompleted': 'Completados',
  'projects.filterArchived': 'Archivados',
  'projects.statusRecruiting': 'Reclutando',
  'projects.statusInProgress': 'En Progreso',
  'projects.statusPaused': 'Pausado',
  'projects.statusCompleted': 'Completado',
  'projects.statusCancelled': 'Cancelado',
  'projects.applicationPending': 'Pendiente',
  'projects.applicationReviewing': 'En Revisión',
  'projects.applicationAccepted': 'Aceptada',
  'projects.applicationRejected': 'Rechazada',
  'projects.applicationWithdrawn': 'Retirada',
  'projects.appliedOn': 'Aplicado el',
  'projects.role': 'Rol',
  'projects.withdraw': 'Retirar',
  'projects.applyNow': 'Aplicar Ahora',
  'projects.viewDetails': 'Ver Detalles',
  'projects.resources': 'Recursos',
  'projects.budget.title': 'Presupuesto',
  'projects.noTasksYet': 'Sin tareas todavía',
  'projects.addTask': 'Agregar Tarea',

  // ─── Mercado ───────────────────────────────────────────────────────────────
  'marketplace.title': 'Mercado',
  'marketplace.subtitle': 'Encontrá trabajos, locales y oportunidades',
  'marketplace.gigs': 'Trabajos',
  'marketplace.venues': 'Locales',
  'marketplace.postGig': 'Publicar Trabajo',
  'marketplace.createVenue': 'Agregar Local',
  'marketplace.gigTitle': 'Título del Trabajo',
  'marketplace.gigDescription': 'Descripción',
  'marketplace.gigDate': 'Fecha',
  'marketplace.gigLocation': 'Ubicación',
  'marketplace.gigPay': 'Pago',
  'marketplace.applyToGig': 'Aplicar al Trabajo',
  'marketplace.applicationSent': 'Aplicación enviada exitosamente',
  'marketplace.applicationError': 'Error al enviar la aplicación',
  'marketplace.noGigs': 'No hay trabajos disponibles',
  'marketplace.noVenues': 'No hay locales disponibles',
  'marketplace.myGigs': 'Mis Trabajos',
  'marketplace.myBookings': 'Mis Reservas',
  'marketplace.myVenues': 'Mis Locales',
  'marketplace.bookingStatus': 'Estado de Reserva',
  'marketplace.bookingPending': 'Pendiente',
  'marketplace.bookingConfirmed': 'Confirmada',
  'marketplace.bookingCompleted': 'Completada',
  'marketplace.bookingCancelled': 'Cancelada',
  'marketplace.capacity': 'Capacidad',
  'marketplace.genre': 'Género',
  'marketplace.contactVenue': 'Contactar Local',
  'marketplace.viewVenue': 'Ver Local',
  'marketplace.applyAs': 'Aplicar como',
  'marketplace.coverLetter': 'Carta de Presentación',
  'marketplace.gigType': 'Tipo de Trabajo',

  // ─── Mensajes ──────────────────────────────────────────────────────────────
  'messages.title': 'Mensajes',
  'messages.conversations': 'Conversaciones',
  'messages.newMessage': 'Nuevo Mensaje',
  'messages.typeMessage': 'Escribí un mensaje...',
  'messages.noConversations': 'Todavía no hay conversaciones',
  'messages.noConversationsHint': 'Iniciá una conversación desde el perfil de un músico o desde una página de proyecto.',
  'messages.sendError': 'Error al enviar el mensaje',
  'messages.markAsRead': 'Marcar como leído',
  'messages.deleteConversation': 'Eliminar conversación',
  'messages.welcomeTitle': 'Bienvenido a Mensajes',
  'messages.welcomeSubtitle': 'Seleccioná una conversación de la lista para empezar a chatear, o iniciá una nueva desde el perfil de un músico o una página de proyecto.',
  'messages.noMessages': 'Todavía no hay mensajes',
  'messages.startConversation': '¡Iniciá la conversación!',
  'messages.someoneIsTyping': 'está escribiendo...',
  'messages.loadingMessages': 'Cargando mensajes...',
  'messages.sendMessage': 'Enviar',
  'messages.attachFile': 'Adjuntar archivo',
  'messages.online': 'En línea',
  'messages.offline': 'Desconectado',
  'messages.lastSeen': 'Visto por última vez',
  'messages.loadingMore': 'Cargando más...',
  'messages.loadMore': 'Cargar más mensajes',
  'messages.welcome': 'Bienvenido a Mensajes',
  'messages.selectConversation': 'Seleccioná una conversación de la lista para empezar a chatear, o iniciá una nueva desde el perfil de un músico o una página de proyecto.',
  'messages.micError': 'No se pudo acceder al micrófono',
  'messages.geoNotSupported': 'La geolocalización no está soportada',
  'messages.geoError': 'No se pudo obtener tu ubicación',
  'messages.voiceMessage': 'Mensaje de voz',

  // ─── Notificaciones ────────────────────────────────────────────────────────
  'notifications.title': 'Notificaciones',
  'notifications.markAllRead': 'Marcar todas como leídas',
  'notifications.noNotifications': 'Sin notificaciones',
  'notifications.settings': 'Configuración de Notificaciones',
  'notifications.emailNotifications': 'Notificaciones por Email',
  'notifications.pushNotifications': 'Notificaciones Push',
  'notifications.inAppNotifications': 'Notificaciones en la App',
  'notifications.doNotDisturb': 'No Molestar',
  'notifications.enablePush': 'Activar Notificaciones Push',
  'notifications.disablePush': 'Desactivar Notificaciones Push',
  'notifications.permissionDenied': 'Permiso de notificaciones push denegado',
  'notifications.subscribeSuccess': 'Notificaciones push activadas',
  'notifications.unsubscribeSuccess': 'Notificaciones push desactivadas',
  'notifications.newMessage': 'Nuevo mensaje',
  'notifications.collaborationRequest': 'Solicitud de colaboración',
  'notifications.projectUpdate': 'Actualización de proyecto',
  'notifications.gigApplication': 'Aplicación a trabajo',

  // ─── Inicio ────────────────────────────────────────────────────────────────
  'home.recentActivity': 'Actividad Reciente',
  'home.upcomingEvents': 'Próximos Eventos',
  'home.nearbyMusicians': 'Músicos Cercanos',
  'home.editProfile': 'Editar Perfil',
  'home.findMusicians': 'Buscar Músicos',
  'home.goLive': 'Transmitir en Vivo',
  'home.events': 'Eventos',

  // ─── Perfil Público / Músico ───────────────────────────────────────────────
  'musician.plays': 'reproducciones',
  'musician.likes': 'me gusta',
  'musician.tracks': 'Pistas',
  'musician.playlists': 'Listas',
  'musician.about': 'Acerca de',
  'musician.contact': 'Contactar',
  'musician.sendMessage': 'Enviar Mensaje',
  'musician.requestCollab': 'Solicitar Colaboración',
  'musician.bpm': 'BPM',
  'musician.key': 'Tonalidad',
  'musician.duration': 'Duración',
  'musician.genre': 'Género',
  'musician.instrument': 'Instrumento',
  'musician.experience': 'Experiencia',
  'musician.location': 'Ubicación',

  // ─── Detalle de Pista ──────────────────────────────────────────────────────
  'track.plays': 'reproducciones',
  'track.uploadedOn': 'Subida el',
  'track.shareLink': '¡Enlace copiado!',
  'track.comments': 'Comentarios',
  'track.addComment': 'Agregá un comentario...',
  'track.technicalDetails': 'Detalles Técnicos',

  // ─── Onboarding ────────────────────────────────────────────────────────────
  'onboarding.title': 'Completá tu perfil',
  'onboarding.subtitle': 'Contanos sobre vos para encontrar los mejores músicos',
  'onboarding.step1.title': 'Tu foto de perfil',
  'onboarding.step1.description': 'Subí una foto para que otros músicos te reconozcan',
  'onboarding.step1.upload': 'Subir foto',
  'onboarding.step1.skip': 'Saltear este paso',
  'onboarding.step2.title': 'Tus instrumentos',
  'onboarding.step2.description': 'Seleccioná los instrumentos que tocás (mínimo 1)',
  'onboarding.step3.title': 'Tus géneros musicales',
  'onboarding.step3.description': 'Elegí los géneros que más te identifican (mínimo 1)',
  'onboarding.step4.title': 'Tu ubicación',
  'onboarding.step4.description': 'Ayudanos a conectarte con músicos cerca tuyo',
  'onboarding.step4.city': 'Ciudad',
  'onboarding.step4.country': 'País',
  'onboarding.next': 'Siguiente',
  'onboarding.previous': 'Anterior',
  'onboarding.finish': 'Finalizar',
  'onboarding.saving': 'Guardando...',
  'onboarding.stepOf': 'Paso {current} de {total}',

  // ─── CreateGig ───────────────────────────────────────────────────────────────
  'gig.create.title': 'Publicar nuevo gig',
  'gig.create.description': 'Creá una oportunidad para músicos',
  'gig.form.venue': 'Venue',
  'gig.form.venue.placeholder': 'Seleccioná un venue',
  'gig.form.venue.empty': 'Necesitás crear un venue primero.',
  'gig.form.venue.create': 'Crear venue',
  'gig.form.title': 'Título del gig',
  'gig.form.title.placeholder': 'Ej: Jazz Night — Sábado',
  'gig.form.description': 'Descripción',
  'gig.form.description.placeholder': 'Describí el gig, expectativas y qué deben saber los músicos...',
  'gig.form.type': 'Tipo de gig',
  'gig.form.type.placeholder': 'Seleccioná el tipo',
  'gig.form.date': 'Fecha y hora',
  'gig.form.duration': 'Duración (horas)',
  'gig.form.budgetMin': 'Presupuesto mínimo ($)',
  'gig.form.budgetMax': 'Presupuesto máximo ($)',
  'gig.form.genres': 'Géneros',
  'gig.form.requirements': 'Requisitos',
  'gig.form.requirements.placeholder': 'Equipo necesario, nivel de experiencia, vestimenta, etc.',
  'gig.form.submit': 'Publicar gig',
  'gig.form.submitting': 'Publicando...',
  'gig.created.success': 'Gig publicado exitosamente',
  // Validaciones gig
  'gig.validation.venue': 'Seleccioná un venue',
  'gig.validation.title.min': 'Mínimo 3 caracteres',
  'gig.validation.title.max': 'Máximo 100 caracteres',
  'gig.validation.description.min': 'Mínimo 20 caracteres',
  'gig.validation.description.max': 'Máximo 2000 caracteres',
  'gig.validation.type': 'Seleccioná el tipo de gig',
  'gig.validation.date': 'La fecha es requerida',
  'gig.validation.date.future': 'La fecha debe ser en el futuro',
  'gig.validation.genres': 'Seleccioná al menos un género',
  'gig.validation.budget': 'El presupuesto máximo debe ser ≥ al mínimo',
  // ─── CreateVenue ─────────────────────────────────────────────────────────────
  'venue.create.title': 'Crear nuevo venue',
  'venue.create.description': 'Agregá tu venue al marketplace',
  'venue.form.name': 'Nombre del venue',
  'venue.form.name.placeholder': 'Ej: The Blue Note Club',
  'venue.form.description': 'Descripción',
  'venue.form.description.placeholder': 'Describí tu venue, su ambiente y qué lo hace especial...',
  'venue.form.location': 'Ubicación',
  'venue.form.location.placeholder': 'Ciudad, Provincia/País',
  'venue.form.capacity': 'Capacidad',
  'venue.form.capacity.placeholder': 'Ej: 200',
  'venue.form.type': 'Tipo de venue',
  'venue.form.type.placeholder': 'Seleccioná el tipo',
  'venue.form.email': 'Email de contacto',
  'venue.form.phone': 'Teléfono de contacto',
  'venue.form.phone.placeholder': '+54 9 11 1234-5678',
  'venue.form.website': 'Sitio web',
  'venue.form.website.placeholder': 'https://tuvenue.com',
  'venue.form.imageUrl': 'URL de imagen',
  'venue.form.imageUrl.placeholder': 'https://example.com/imagen.jpg',
  'venue.form.submit': 'Crear venue',
  'venue.form.submitting': 'Creando...',
  'venue.created.success': 'Venue creado exitosamente',
  // Validaciones venue
  'venue.validation.name.min': 'Mínimo 3 caracteres',
  'venue.validation.name.max': 'Máximo 100 caracteres',
  'venue.validation.location': 'La ubicación es requerida',
  'venue.validation.type': 'Seleccioná el tipo de venue',
  'venue.validation.email': 'Email inválido',
  'venue.validation.capacity': 'Debe ser un número entero positivo',
  'venue.validation.url': 'URL inválida (debe empezar con https://)',

  // ─── Errores comunes ─────────────────────────────────────────────────────────
  'error.failedToLoad': 'Error al cargar los datos',
  'error.failedToLoadData': 'No se pudieron cargar los datos',
  'error.accessDenied': 'Acceso denegado',
  'error.pageNotFound': 'Página no encontrada',
  'error.pageNotFoundHint': 'La página que buscás no existe.',
  'error.goHome': 'Ir al inicio',
  'error.somethingWentWrong': 'Algo salió mal',
  'error.tryAgain': 'Intentar de nuevo',
  'error.unknown': 'Ocurrió un error inesperado',
  'error.network': 'Error de conexión. Verificá tu internet.',
  'error.timeout': 'La operación tardó demasiado. Intentá de nuevo.',
  'error.duplicate': 'Este registro ya existe.',
  'error.foreignKey': 'No se encontró una referencia relacionada.',
  'error.invalidData': 'Los datos proporcionados no son válidos.',
  'error.notFound': 'No se encontró el recurso solicitado.',
  'auth.emailNotConfirmed': 'Tu correo aún no fue confirmado. Revisá tu bandeja de entrada.',
  'auth.alreadyRegistered': 'Este correo ya está registrado.',
  'error.invalidId': 'ID inválido',
  'error.sendingRequest': 'Error al enviar la solicitud',
  'error.loadingProfile': 'Error al cargar el perfil',
  'error.pleaseLogin': 'Iniciá sesión para continuar',
  'error.withdrawFailed': 'Error al retirar la aplicación',

  // ─── Éxito ───────────────────────────────────────────────────────────────────
  'success.applicationWithdrawn': 'Aplicación retirada exitosamente',
  'success.searchSaved': 'Preferencia de búsqueda guardada',

  // ─── Placeholders ────────────────────────────────────────────────────────────
  'placeholder.allTypes': 'Todos los tipos',
  'placeholder.venueType': 'Tipo de venue',
  'placeholder.yourName': 'Tu nombre',
  'placeholder.yourEmail': 'Tu email',
  'placeholder.message': 'Mensaje',

  // ─── Labels ──────────────────────────────────────────────────────────────────
  'label.user': 'Usuario',
  'label.musician': 'Músico',
  'label.project': 'Proyecto',
  'label.locationNotSet': 'Ubicación no configurada',
  'label.availabilityNotSet': 'Disponibilidad no configurada',
  'label.noBio': 'Sin biografía',

  // ─── Validación ──────────────────────────────────────────────────────────────
  'validation.emailRequired': 'El correo electrónico es obligatorio',
  'validation.emailInvalid': 'El correo electrónico no es válido',
  'validation.passwordRequired': 'La contraseña es obligatoria',
  'validation.passwordMinLength': 'La contraseña debe tener al menos 8 caracteres',
  'validation.confirmPasswordRequired': 'La confirmación de contraseña es obligatoria',
  'validation.displayNameRequired': 'El nombre es obligatorio',
  'validation.displayNameMaxLength': 'El nombre no puede exceder 50 caracteres',
  'validation.passwordsMustMatch': 'Las contraseñas no coinciden',
  'validation.bioMaxLength': 'La biografía no puede exceder 500 caracteres',
  'validation.cityMaxLength': 'La ciudad no puede exceder 100 caracteres',
  'validation.countryMaxLength': 'El país no puede exceder 100 caracteres',
  'validation.yearsExperienceMin': 'Los años de experiencia no pueden ser negativos',
  'validation.yearsExperienceMax': 'Los años de experiencia no pueden exceder 99',
  'validation.currentPasswordRequired': 'La contraseña actual es obligatoria',
  'validation.instrumentsRequired': 'Selecciona al menos un instrumento',
  'validation.genresRequired': 'Selecciona al menos un género',
  'validation.cityRequired': 'La ciudad es obligatoria',
  'validation.countryRequired': 'El país es obligatorio',
  'validation.projectNameRequired': 'El nombre del proyecto es obligatorio',
  'validation.projectNameMaxLength': 'El nombre no puede exceder 100 caracteres',
  'validation.projectDescriptionRequired': 'La descripción del proyecto es obligatoria',
  'validation.projectDescriptionMaxLength': 'La descripción no puede exceder 2000 caracteres',
  'validation.locationMaxLength': 'La ubicación no puede exceder 200 caracteres',
  'validation.objectivesMaxLength': 'Los objetivos no pueden exceder 1000 caracteres',
  'validation.gigTitleRequired': 'El título del evento es obligatorio',
  'validation.gigTitleMaxLength': 'El título no puede exceder 200 caracteres',
  'validation.gigDescriptionRequired': 'La descripción del evento es obligatoria',
  'validation.gigDescriptionMaxLength': 'La descripción no puede exceder 2000 caracteres',
  'validation.gigTypeRequired': 'El tipo de evento es obligatorio',
  'validation.gigDateRequired': 'La fecha del evento es obligatoria',
  'validation.gigDurationMin': 'La duración mínima es 0.5 horas',
  'validation.gigDurationMax': 'La duración máxima es 24 horas',
  'validation.budgetMin': 'El presupuesto mínimo no puede ser negativo',
  'validation.budgetMax': 'El presupuesto máximo no puede ser negativo',
  'validation.venueNameRequired': 'El nombre del venue es obligatorio',
  'validation.venueNameMaxLength': 'El nombre no puede exceder 200 caracteres',
  'validation.venueDescriptionMaxLength': 'La descripción no puede exceder 2000 caracteres',
  'validation.venueLocationRequired': 'La ubicación del venue es obligatoria',
  'validation.venueLocationMaxLength': 'La ubicación no puede exceder 200 caracteres',
  'validation.venueCapacityMin': 'La capacidad debe ser al menos 1',
  'validation.venueTypeRequired': 'El tipo de venue es obligatorio',
};
